import { Container, Row, Col, Card } from 'react-bootstrap';

const Community = () => {
  const guidelines = [
    {
      icon: 'bi-person-check',
      title: 'Be Authentic',
      description: 'Use recent photos that accurately represent you. Be honest in your profile and conversations. Authenticity builds trust and leads to better connections.'
    },
    {
      icon: 'bi-heart',
      title: 'Be Respectful',
      description: 'Treat everyone with kindness and respect. Accept rejection gracefully and don\'t pressure others. Remember there\'s a real person behind every profile.'
    },
    {
      icon: 'bi-shield',
      title: 'Keep It Safe',
      description: 'Don\'t share personal information too quickly. Report suspicious behavior. Follow our safety tips when meeting in person.'
    },
    {
      icon: 'bi-chat-square-heart',
      title: 'Communicate Clearly',
      description: 'Be clear about your intentions and what you\'re looking for. Respond to messages in a timely manner. If you\'re not interested, a polite decline is appreciated.'
    },
    {
      icon: 'bi-ban',
      title: 'No Harassment',
      description: 'Harassment, bullying, or threatening behavior is never acceptable. This includes unwanted sexual messages, hate speech, or discriminatory language.'
    },
    {
      icon: 'bi-camera',
      title: 'Appropriate Content',
      description: 'Keep photos and messages appropriate. No nudity, explicit content, or offensive material. Violating content will be removed and may result in account suspension.'
    }
  ];

  const notAllowed = [
    'Fake profiles or impersonation',
    'Spam or commercial solicitation',
    'Harassment or threatening behavior',
    'Hate speech or discrimination',
    'Explicit or inappropriate content',
    'Scams or requests for money',
    'Underage users (must be 18+)',
    'Multiple accounts'
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Community Guidelines</h1>
          <p className="lead text-muted">
            Our community is built on respect, authenticity, and safety. These guidelines help create 
            a positive environment for everyone.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        {guidelines.map((guideline, index) => (
          <Col lg={4} md={6} key={index} className="mb-4">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body className="p-4 text-center">
                <i className={`bi ${guideline.icon} display-4 text-primary mb-3`}></i>
                <h5 className="fw-bold mb-3">{guideline.title}</h5>
                <p className="text-muted mb-0">{guideline.description}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="mb-5">
        <Col lg={6} className="mb-4 mb-lg-0">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="p-4">
              <h4 className="fw-bold mb-4">
                <i className="bi bi-x-circle me-2"></i>
                Not Allowed
              </h4>
              <ul className="list-unstyled mb-0">
                {notAllowed.map((item, index) => (
                  <li key={index} className="mb-2 d-flex align-items-center">
                    <i className="bi bi-x-lg text-danger me-2"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="p-4">
              <h4 className="fw-bold mb-4">
                <i className="bi bi-flag text-primary me-2"></i>
                Reporting Violations
              </h4>
              <p className="text-muted mb-3">
                If you see content or behavior that violates these guidelines, please report it:
              </p>
              <ul className="text-muted mb-3">
                <li className="mb-2">Use the report button on any profile or message</li>
                <li className="mb-2">Email us at <a href="mailto:report@paperdate.io">report@paperdate.io</a></li>
                <li className="mb-2">Block users who make you uncomfortable</li>
              </ul>
              <p className="text-muted mb-0">
                <strong>Consequences:</strong> Violations may result in warnings, temporary suspension, 
                or permanent account removal depending on severity.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Community;

